import { createVNode as _createVNode } from "vue";
/**
 * @author xiezhixiong
 * @fileoverview 头部标题
 */
import { defineComponent } from "vue";
import useRespondTo from "@/hooks/common/respond-to";
export default defineComponent({
  name: 'ZoneHeader',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const {
      isMobile
    } = useRespondTo();
    return () => {
      return _createVNode("div", {
        "class": ['zone-header', isMobile.value && 'zone-header-m']
      }, [_createVNode("div", {
        "class": ['zone-header-line', isMobile.value && 'zone-header-m-line']
      }, [_createVNode("div", {
        "class": ['zone-header-line-rect', isMobile.value && 'zone-header-m-line-rect']
      }, null)]), _createVNode("div", {
        "class": ['zone-header-title', isMobile.value && 'zone-header-m-title']
      }, [props.title]), _createVNode("div", {
        "class": ['zone-header-line', 'zone-header-line__reverse', isMobile.value && 'zone-header-m-line']
      }, [_createVNode("div", {
        "class": ['zone-header-line-rect', isMobile.value && 'zone-header-m-line-rect']
      }, null)])]);
    };
  }
});